import {USER_LOGIN_TYPES} from '../constants/userLogin.types'
import {Dispatch} from 'react'
import {
  generalOpenModalError,
  generalOpenModalInfo,
  generalOpenModalLimite,
  generalOpenModalSuscripcion,
  generalShowLoader,
} from './general.actions'
import * as http from '../api/http'
import {ENDPOINTS} from '../api/config'
import {KEYS} from '../constants/keysStorage'
import { limitesSuscripcion } from '../interfaces/general.interface'
import { State } from '../reducers'
import { cerrarSesion } from './general.actions'
import { catalogosClear } from './catalogos.actions'
import { facturacionClearAll } from './facturacion/facturacionEmision.actions'
import { handleRestarFlujo as handleRestarFlujoNotaRemision } from './nota-remision.actions'
import { handleRestarFlujo as handleRestarFlujoFacturaExportacion } from './factura-exportacion.actions'
import { handleRestarFlujo } from './credito-fiscal.actions'
import { handleRestarFlujo as handleRestarFlujoNCE } from './nota-credito-externo.actions'
import { handleRestarFlujo as handleRestarFlujoCL } from './comprobante-liquidacion'
import { sujetoExcluidoClearAll } from './sujeto-excluido/sujetoExcluidoEmision.actions'
import { comprobanteRetencionClearAll } from './comprobante-retencion/comprobanteRetencionEmision.actions'
import { setResetHistorial } from './historial/historial.actions'
import { docsAsociadosReset } from './documentos/documentos.actions'
import { useHistory } from 'react-router-dom'
import { handleRestartStateFormaPago } from './forma-pago.actions'

export const userLoginSave = (user: any) => ({
  type: USER_LOGIN_TYPES.SAVE_USER_LOGIN,
  payload: user,
})

export const userSaveLogo = (logoBase64: string|ArrayBuffer) => ({
  type: USER_LOGIN_TYPES.SAVE_EMPRESA_LOGO,
  payload: logoBase64,
})

export const updateUserLocalData = (data: any) => ({
  type: USER_LOGIN_TYPES.UPDATE_DATA_USER,
  payload: data,
})

export const updateConfigData = (data: any) => ({
  type: USER_LOGIN_TYPES.UPDATE_DATA_CONFIG,
  payload: data,
})

export const changeDimensionsScreen = (width: Number) => ({
  type: USER_LOGIN_TYPES.CHANGE_DIMENSIONS,
  payload: {width},
})

export const saveLimiteSuscripcion = (limite: Number) => ({
  type: USER_LOGIN_TYPES.SAVE_LIMITE,
  payload: limite,
})

export const receiveSessionData = (component: string|undefined, data: any) => ({
  type: USER_LOGIN_TYPES.SAVE_SESSION_DATA,
  payload: data,
  component: component
})


// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const suscripcionGetFacturasDisponibles = () => async (dispatch: Dispatch<any>, getState: () => State) => {
  let message = 'No se lograron obtener los datos de la suscripción.'
  let id_user = localStorage.getItem(KEYS.ID_CLIENT) || ''
  suscripcionVerificacionLimiteFacturas(dispatch, getState)

  http
    .post(ENDPOINTS.SUSCRIPCION_POST_FACTURAS_DISPONIBLES, {id_user})
    .then((res: any) => {
      if (res?.status === 200 || res?.message === 'Usuario encontrado.') {
        if (res?.data === true) {
          dispatch(generalShowLoader(false))
          dispatch(generalOpenModalSuscripcion())
        }
        return
      }
      dispatch(generalOpenModalError(res?.message ?? message))
    })
    .catch((err: any) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}

export const getConfigData = () => async (dispatch: Dispatch<any>, getState: () => State) => {
  // Obtener configuracion de la empresa
  let message = 'No se lograron obtener los datos de la configuración base.'
  await http
    .get(ENDPOINTS.GET_CONFIG_INFO)
    .then((res: any) => {
      if (res?.status === 200) {
        if (res?.data) {
          dispatch(generalShowLoader(false))
          dispatch(updateConfigData(res.data))
        }
        return
      }
      dispatch(generalOpenModalError(res?.message ?? message))
    })
    .catch((err: any) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}

export const suscripcionVerificacionLimiteFacturas = async (dispatch: Dispatch<any>, getState: () => State) => {
  let username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
  let message = 'No se lograron obtener los datos de la suscripción.'
  let limite = getState().userLogin.limite

  http.get(ENDPOINTS.PERFIL_USUARIO_GET_USUARIO, {username})
  .then((res: any) => {
    if (res?.status === 200) {
      let calculo = (res?.data?.facturas_emitidas / res?.data?.facturas_maximas)*100
      limitesSuscripcion.forEach(element => {
        if(calculo >= element.inferior && calculo < element.superior) {
          if(limite === element.superior) return
          const name = localStorage.getItem(KEYS.NAME_CLIENT)?.toLowerCase()
          const mensaje = `Estimado <span style="text-transform: capitalize;">${name}</span>, le informamos que le quedan ${((res?.data?.facturas_maximas - res?.data?.facturas_emitidas)).toLocaleString('en-US')} de facturas disponibles.`
          dispatch(generalOpenModalLimite(mensaje, element.superior, element.color, "Alerta de suscripción"))
          return;
        }
      });
      return
    }
    dispatch(generalOpenModalError(res?.message ?? message))
  })
  .catch((err: any) => {
    dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
  })
}

export const RefreshToken = async () => {
  const token = localStorage.getItem(KEYS.TOKEN)

  if(token)
    await http.get(ENDPOINTS.REFRESH_TOKE_POST, {})
    .then((res: any) => {
      if (res && res?.data !== null && res?.status === 200) {
        if(res.data.token){
          let token = res.data.newToken
          localStorage.setItem(KEYS.TOKEN, token)
        }
      } 
      if (res?.status === 401) {
        cerrarSesion()
        localStorage.setItem(KEYS.MESSAGE_SESSION_ERROR, res?.data?.message);
        window.location.replace(`/sesion-caducada`)
      }
    })
    .catch((error) => {
      cerrarSesion()
      localStorage.setItem(KEYS.MESSAGE_SESSION_ERROR, error?.data?.message);
      window.location.replace(`/sesion-caducada`)
    })
}

export const RefreshTokenCore = async () => {
  const token = localStorage.getItem(KEYS.TOKEN)

  if(token)
    http.get(ENDPOINTS.REFRESH_TOKEN_CORE, {}, KEYS.TOKEN)
    .then((res: any) => {
      if (res && res?.body !== null) {
        let token = res?.body?.TokenGateway
        localStorage.setItem(KEYS.TOKEN, token)
      } 
      if (res?.status === 401) {
        cerrarSesion()
        localStorage.setItem(KEYS.MESSAGE_SESSION_ERROR, res?.data?.message);
        window.location.replace(`/sesion-caducada`)
      }
    })
    .catch((error) => {
      cerrarSesion()
      localStorage.setItem(KEYS.MESSAGE_SESSION_ERROR, error?.data?.message);
      window.location.replace(`/sesion-caducada`)
    })
}

export const showMessageSucursalVacia = (tipoDoc: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
  const {datos} = getState().userLogin;
  const esSupervisor = datos.role === "2";
  
  if (esSupervisor) dispatch(generalOpenModalInfo(`Para poder continuar, por favor ingresa una serie para el documento "${tipoDoc}"`))
  else dispatch(generalOpenModalInfo(`Para poder continuar, por favor solicita a tu supervisor ingresar una serie para el documento "${tipoDoc}"`))
}

export const clearDataRedux = () => async (dispatch: Dispatch<any>) => {
  cerrarSesion()
  dispatch(handleRestartStateFormaPago())
  dispatch(catalogosClear())
  dispatch(userLoginSave({}))
  dispatch(facturacionClearAll(true))
  dispatch(docsAsociadosReset())
  dispatch(sujetoExcluidoClearAll(true))
  dispatch(comprobanteRetencionClearAll(true))
  dispatch(handleRestarFlujo()) //Credito Fiscal
  dispatch(handleRestarFlujoFacturaExportacion())
  dispatch(handleRestarFlujoNotaRemision())
  dispatch(receiveSessionData(undefined, []))
  dispatch(setResetHistorial())
  dispatch(handleRestarFlujoNCE())  //Credito Fiscal externo
  dispatch(handleRestarFlujoCL())
}
